<template>
  <base-card
    :heading="heading"
    :icons="icons"
    @icon-clicked="iconClicked"
    :scrollable="true"
  >
    <map-display-with-details
      v-for="(location, index) in array"
      :key="index"
      :location="location"
      :fetched="fetched"
      @remove-location="removeLocation(index)"
    />
  </base-card>
</template>
<script>
import MapDisplayWithDetails from "../UI/ListItems/Location/MapDisplayWithDetails.vue";
import BaseCard from "../UI/BaseCard.vue";

export default {
  data() {
    return {};
  },
  computed: {
    array() {
      if (this.fetched) {
        return this.locations;
      } else {
        return [];
      }
    },
  },
  methods: {
    iconClicked(icon) {
      this.$emit("icon-clicked", icon);
    },
    removeLocation(index) {
      this.$emit("remove-location", index);
    },
  },
  components: {
    BaseCard,
    MapDisplayWithDetails,
  },
  emits: ["icon-clicked", "remove-location"],
  props: ["locations", "icons", "heading", "fetched"],
};
</script>
<style scoped></style>
